import a4SizeInPixels from "./utils/a4SizeInPixels";
let myhost = window.location.protocol + '//' + window.location.host;
export default {
    // host: '',
    // host:  window.location.protocol + '//' + window.location.host,
    host: 'https://luckycola.com.cn',
    apiConfig: {
        baseURL: 'http://demo.luckycola.com.cn/init',
        timeout: 60 * 1000 * 10,
        isFormData: false
    },
    pageSizeType: {
        // a4: [a4SizeInPixels().width || 595, a4SizeInPixels().height || 842]
        // a4: [794, 1123],
        a4: [595, 842],
    },
    buyvipUrl: 'http://luckycola.com.cn/public/dist/?autoDetail=1&category=apiList&goodsid=api20231210Y6#/shopStore',
    colaAiUrl: 'https://luckycola.com.cn/public/dist/#/chatAi',
    colaAiUrlV2: 'http://luckycola.com.cn/public/dist/#/aiQStore/qesCusPage',
    aiMindUrl: 'http://luckycola.com.cn/public/dist/#/aiQStore/aiMindPage',
    aiAgentUrl: 'http://luckycola.com.cn/public/dist/aiAgent.html',
    iamgeEditUrl: 'http://luckycola.com.cn/public/dist/imageTool.html',
    goCreateAvatarUrl: 'https://www.pickwant.com/idphoto/guide',
    globalColaKey: 'g3mcARAJqGfkOl1708856584411KjewKQv4iD',//2024-4-25 zhou13118191328@163.com
    aiCreateInfoArr: [
        {
            id: 2,
            title: '金融数据分析师岗位描述示例',
            targetWork: '金融数据分析师',
            character: '严谨细致，逻辑性强，具备数据敏感度',
            userInfoDesc: '我毕业于XX财经大学金融数学专业，硕士学位，拥有2年头部券商数据分析经验。曾参与搭建量化投资模型，使用Python处理过亿级交易数据，独立完成客户风险画像系统开发。精通SQL、Python（Pandas/NumPy）、Tableau可视化，持有CFA一级证书，擅长从市场波动率、PE/PB估值等维度挖掘投资机会，具备出色的报告撰写和跨部门协作能力。'
        },
        {
            id: 3,
            title: '临床护士岗位描述示例',
            targetWork: '临床护士',
            character: '耐心细致，责任感强，抗压能力强',
            userInfoDesc: '我毕业于XX医学院护理学专业，本科学历，持有护士资格证，拥有3年三甲医院心内科护理经验。熟练掌握心电图监测、静脉置管等专科操作，参与过200+台介入手术配合，主导完成科室护理流程优化项目，使药品核对错误率下降45%。具备危急重症抢救经验，多次获得院级“服务之星”称号。'
        },
        {
            id: 4,
            title: '高级UI/UX设计师岗位描述示例',
            targetWork: '高级UI/UX设计师',
            character: '创新思维，用户导向，注重细节',
            userInfoDesc: '我毕业于中央美术学院数字媒体专业，学士学位，拥有4年一线互联网公司设计经验。曾主导某千万级用户APP的交互重构项目，通过用户旅程地图分析提升转化率18%。精通Figma、Sketch及动效设计工具，熟悉Ant Design设计规范，主导输出3套品牌视觉系统，获得2024 UXPA设计奖项。'
        },
        {
            id: 5,
            title: '机器学习工程师岗位描述示例',
            targetWork: '机器学习工程师',
            character: '逻辑思维强，持续学习，注重实践',
            userInfoDesc: '我毕业于清华大学计算机科学与技术专业，硕士学位，拥有2年AI算法开发经验。曾主导开发基于LSTM的文本分类模型，在Kaggle竞赛中排名Top3%，优化BERT预训练框架使推理速度提升60%。精通PyTorch、TensorFlow及分布式训练技术，熟悉图像处理、NLP等应用场景，持有AWS云架构师认证。'
        },
        {
            id: 6,
            title: '市场营销经理岗位描述示例',
            targetWork: '快消行业市场营销经理',
            character: '创意丰富，市场敏感，沟通协调强',
            userInfoDesc: '我毕业于复旦大学市场营销专业，MBA学位，拥有5年宝洁品牌管理经验。曾策划“双十一”全域营销战役，实现销售额同比增长120%，主导开发社交媒体KOL矩阵，覆盖用户超500万。精通数字营销工具（Google Analytics/SEO），擅长消费者洞察与跨界合作，带领团队完成多个年度营销大奖案例。'
        },
        {
            id: 7,
            title: 'SaaS产品经理岗位描述示例',
            targetWork: 'SaaS高级产品经理',
            character: '用户导向，系统思维，执行力突出',
            userInfoDesc: '我毕业于浙江大学软件工程系，拥有4年企业级SaaS产品设计经验。曾从0到1搭建智能CRM系统，完成3轮用户调研与原型迭代，上线后客户留存率提升35%。精通Axure、Jira等工具链，擅长需求文档撰写与技术对接，主导完成ISO27001安全认证，具备敏捷开发项目管理经验。'
        },
        {
            id: 8,
            title: '中学数学教师岗位描述示例',
            targetWork: '中学数学教师',
            character: '亲和力强，因材施教，注重引导',
            userInfoDesc: '我毕业于北京师范大学数学与应用数学专业，教育学硕士学位，拥有6年重点中学教学经验。曾带领班级数学平均分提升20分，获省级教学技能大赛一等奖。开发“数学建模与生活”校本课程，受聘参与市级教师培训项目，擅长将抽象概念转化为可视化教学案例。'
        },
        {
            id: 9,
            title: '芯片设计高级硬件工程师岗位描述示例',
            targetWork: '芯片设计高级硬件工程师',
            character: '技术执着，创新思维，跨领域协作',
            userInfoDesc: '我毕业于电子科技大学微电子专业，博士学位，拥有3年头部芯片公司研发经验。曾主导完成低功耗蓝牙SoC架构设计，参与流片成功率达95%，优化功耗指标超行业基准30%。精通Verilog、SystemVerilog及EDA工具链，熟悉数字/模拟混合信号设计流程，持有3项集成电路布图设计专利。'
        },
        {
            id: 10,
            title: '医疗大健康高级客户经理岗位描述示例',
            targetWork: '医疗大健康高级客户经理',
            character: '客户导向，战略思维，资源整合',
            userInfoDesc: '我毕业于中山大学药学专业，MBA学位，拥有8年跨国药企销售经验。曾开拓华南区三甲医院渠道，年销售额突破2亿元，主导完成3个创新药进院项目。精通带量采购政策解读，搭建区域KOL网络覆盖超200家医疗机构，多次获得全球销售精英峰会奖项。'
        },
        {
            id: 11,
            title: "量化投资经理岗位描述示例",
            targetWork: "量化投资经理",
            character: "数学建模，风险管理，策略优化",
            userInfoDesc: "我拥有北京大学金融数学博士学位，3年顶级对冲基金量化投资经验。开发并维护多个基于机器学习的交易策略，年化收益率稳定在15%以上。精通Python、R语言及SQL，擅长处理大规模金融数据，构建风险模型。在资产配置、算法交易领域有深入研究，曾在国际量化投资会议上发表多篇论文，具备将复杂数学模型转化为实际投资策略的能力。"
        },
        {
            id: 12,
            title: "在线课程研发总监岗位描述示例",
            targetWork: "在线课程研发总监",
            character: "内容创新，教学管理，市场敏锐度",
            userInfoDesc: "我毕业于北京师范大学教育学专业，硕士学位，拥有8年在线教育领域经验，其中5年担任课程研发总监。曾带领团队开发覆盖K12全学科的在线课程体系，服务学员超50万人。擅长将教育理论与市场需求结合，打造差异化课程内容。具备优秀的教学团队管理能力，成功建立了一套课程质量评估体系，提升课程满意度至95%以上。多次受邀在行业论坛分享在线教育创新经验。"
        },
        {
            id: 13,
            title: "互联网高级产品经理岗位描述示例",
            targetWork: "互联网高级产品经理",
            character: "用户洞察，产品规划，跨部门协作",
            userInfoDesc: "我毕业于清华大学计算机科学与技术专业，拥有5年知名互联网公司产品经理经验。曾主导开发一款日活超百万的社交APP，负责从市场调研、需求文档撰写到产品上线全周期管理。擅长用户行为分析，通过A/B测试优化产品功能，提升用户留存率15%。具备出色的跨部门沟通协调能力，成功推动技术、设计、市场团队高效合作，多次获得公司创新奖。"
        },
        {
            id: 14,
            title: "酒店前台岗位描述示例",
            targetWork: "酒店前台",
            character: "服务意识强，沟通协调能力佳，细致耐心",
            userInfoDesc: "我毕业于旅游管理专业，拥有3年五星级酒店前台工作经验。熟练掌握酒店管理系统操作（Opera、Fidelio），能够独立处理客人入住退房、预订查询、投诉处理等各类事务。具备良好的中英文沟通能力，曾为多位外籍VIP客人提供专属接待服务，客户满意度保持在95%以上。擅长协调各部门配合，处理突发状况应变能力强，多次获得「服务之星」和客人表扬信，具备夜班值班经验，能够承担责任并确保酒店24小时高质量服务运营。"
        },
        {
            id: 15,
            title: "便利店店员/营业员岗位描述示例",
            targetWork: "便利店店员/营业员",
            character: "责任心强，服务意识佳，学习能力强",
            userInfoDesc: "我有2年便利店工作经验，曾在7-11、全家等知名连锁便利店担任店员。熟练掌握POS收银系统操作，能够处理现金、刷卡、移动支付等多种付款方式，收银准确率保持在99.8%以上。精通商品理货、上架、补货、盘点等零售业务流程，具备良好的商品分类和陈列能力。擅长与顾客沟通，能够主动为顾客介绍商品信息、处理投诉建议，多次获得月度优秀员工称号。具备团队协作精神，能够配合同事完成各项工作任务，维护良好的店内工作氛围。"
        },
        {
            id: 16,
            title: "人力资源(HR)岗位描述示例",
            targetWork: "人力资源专员/主管",
            character: "沟通协调能力强，专业能力扎实，数据分析能力佳",
            userInfoDesc: "我毕业于人力资源管理专业，拥有4年人力资源工作经验，熟悉HR六大模块。曾独立负责公司招聘工作，成功招聘各类人才150+人，招聘达成率95%，将平均招聘周期从30天优化至20天。具备扎实的薪酬绩效管理知识，协助建立绩效考核体系，员工满意度达88%。精通培训管理，组织实施新员工培训项目，转正率提升至92%。熟悉劳动法律法规，具备合规意识，能够有效处理员工关系和劳动纠纷。持有人力资源管理师三级证书，具备优秀的沟通协调能力和数据分析思维。"
        },
    ]

}